import { Component, Input, OnInit } from '@angular/core';
import { Spettacolo } from '../../shared/interface';
import { environment } from '../../../environments/environment.development';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-box-stagione',
  templateUrl: './box-stagione.component.html',
  styleUrl: './box-stagione.component.css'
})
export class BoxStagioneComponent implements OnInit {

  constructor(private router: Router, private datePipe: DatePipe) { }

  @Input() spettacolo?: Spettacolo;
  @Input() card: boolean = true;

  visible: boolean = true;

  ngOnInit(): void {

    // Controllo se è già stato effettuato lo spettacolo
    if (this.spettacolo) {

      const date = this.spettacolo.calendario!.length > 0 && this.spettacolo.calendario!.length <= 1 ? this.datePipe.transform(this.spettacolo.calendario![0].data, 'yyyy-MM-dd') + " " + this.spettacolo!.calendario![0].orario : (this.spettacolo!.calendario!.length == 0 ? this.datePipe.transform(this.spettacolo.al, 'yyyy-MM-dd') : this.datePipe.transform(this.spettacolo.calendario![this.spettacolo.calendario!.length - 1].data, 'yyyy-MM-dd') + " " + this.spettacolo.calendario![this.spettacolo.calendario!.length - 1].orario)
      const time = new Date(date || '').getTime() - new Date().getTime();
      if (time < 300000)
        this.visible = false;
    }

  }

  spettacoloUrl(spettacolo: string | undefined, dal: string | undefined, al: string | undefined): string {      

    let spettacoloUrl = encodeURIComponent(this.toTitleCase(spettacolo!.replace(/[^a-zA-Z0-9 ]/g, '-').toLowerCase()).replace(/ /g, '-'));

    let startDate = new Date(dal!).toISOString().split('T')[0];
    let endDate = new Date(al!).toISOString().split('T')[0];

    return `${startDate}/${endDate}/${spettacoloUrl}`;
  }

  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  onSpettacolo(spettacolo: Spettacolo | undefined) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/stagione/' + this.spettacoloUrl(spettacolo?.spettacolo, spettacolo?.dal.toString(), spettacolo?.al.toString())]);
    });
  }

}
